export const sharedPointsContants = {
  optionsGoogleMapsPolygon: {
    strokeColor: '#696969',
    strokeOpacity: 0.5,
    strokeWeight: 1,
    fillColor: '#B5A6DC',
    fillOpacity: 0.4,
  },
};